/**
 * @generated SignedSource<<517af56db7e145bc2c0a725068638fbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RailTag_tag$data = {
  readonly name: string | null;
  readonly similarItems: {
    readonly category: {
      readonly name: string | null;
      readonly parent: {
        readonly label: string | null;
      } | null;
    } | null;
    readonly items: ReadonlyArray<{
      readonly localizedPdpUrl: string | null;
      readonly photos: ReadonlyArray<{
        readonly versions: ReadonlyArray<{
          readonly webPath: string | null;
        } | null> | null;
      } | null> | null;
      readonly title: string | null;
    } | null> | null;
    readonly searchUrl: string | null;
  } | null;
  readonly " $fragmentType": "RailTag_tag";
};
export type RailTag_tag$key = {
  readonly " $data"?: RailTag_tag$data;
  readonly " $fragmentSpreads": FragmentRefs<"RailTag_tag">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RailTag_tag",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SimilarItemsResults",
      "kind": "LinkedField",
      "name": "similarItems",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "searchUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Category",
          "kind": "LinkedField",
          "name": "category",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Category",
              "kind": "LinkedField",
              "name": "parent",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "localizedPdpUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "limit",
                  "value": 1
                }
              ],
              "concreteType": "ItemPhoto",
              "kind": "LinkedField",
              "name": "photos",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ItemPhotoVersion",
                  "kind": "LinkedField",
                  "name": "versions",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "webPath",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "photos(limit:1)"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradePhotoTag",
  "abstractKey": null
};
})();

(node as any).hash = "fbda1a56e05b9bdd84df3394d07964a1";

export default node;
